import { render, staticRenderFns } from "./DataEmpty.vue?vue&type=template&id=6bb768d3"
import script from "./DataEmpty.vue?vue&type=script&lang=js"
export * from "./DataEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports